import React from 'react';
import { CrmCompanyMainInfo } from './CrmCompanyMainInfo';
import { IDirectoryEntry, ILinkedDirectoryEntryArrayItem } from 'services/CrmApi/types/DirectoryEntry';
import { CrmCompanyActivity } from './CrmCompanyActivity';
import { RouterTabs } from 'ui/RouterTabs';

interface ICrmCompanyTabsProps {
  directoryEntry: IDirectoryEntry;
  contacts: ILinkedDirectoryEntryArrayItem[];
  companies: ILinkedDirectoryEntryArrayItem[];
  onLinkOrUnlink: () => void;
}

export const CrmCompanyTabs: React.FC<ICrmCompanyTabsProps> = ({ directoryEntry, contacts, companies, onLinkOrUnlink }) => {
  const crmCompanyTabs = [
    {
      title: 'Overview',
      route: 'overview',
      styles: 'min-w-[50%]',
      renderContent: () => (
        <CrmCompanyMainInfo 
          directoryEntryId={directoryEntry.id} 
          contacts={contacts}
          companies={companies}
          onLinkOrUnlink={onLinkOrUnlink} 
        />
      ),
    },
    {
      title: 'Activity',
      route: 'activity',
      styles: 'min-w-[50%]',
      renderContent: () => <CrmCompanyActivity directoryEntryId={directoryEntry.id} />,
    },
  ];

  return <RouterTabs tabConfig={crmCompanyTabs} className="o:w-full o:p-0" tabSelectorClassName="o:m-0" />;
};
